<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Dialpad Star Mark Color" class="d-icon d-icon--dialpad-star-mark-color" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.882 11.327c.182-.085.143-.411-.051-.456-2.909-.668-5.173-3.332-5.66-6.674-.031-.222-.41-.274-.487-.066-1.253 3.993-3.964 7.118-7.57 8.642-.176.086-.14.39.048.437 2.84.705 5.046 3.322 5.54 6.599.033.216.38.265.458.062 1.444-4.178 4.21-7.316 7.722-8.544Z" :fill="`url(#${uniqueID}a)`"/><defs><linearGradient :id="`${uniqueID}a`" x1="5" y1="4" x2="20.858" y2="17.876" gradientUnits="userSpaceOnUse"><stop stop-color="#471571"/><stop offset=".031" stop-color="#551B84"/><stop offset=".145" stop-color="#7C229E"/><stop offset=".237" stop-color="#9024A4"/><stop offset=".355" stop-color="#B02290"/><stop offset=".483" stop-color="#D32B86"/><stop offset=".603" stop-color="#E92F6F"/><stop offset=".701" stop-color="#F6484F"/><stop offset=".9" stop-color="#FB7328"/><stop offset=".973" stop-color="#F3960F"/><stop offset="1" stop-color="#F3960F"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconDialpadStarMarkColor',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
